import { useBranding } from '../branding';
export function DragonflyMark({ small = false }: { small?: boolean }) {
  return (
    <svg
      className={small ? 'brand-mark brand-mark-small' : 'brand-mark'}
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <path d="M32 22c-8-15-24-15-21-2 2 8 11 11 20 9M33 22c8-15 24-15 21-2-2 8-11 11-20 9M30 34c-10-2-20 2-18 10 3 9 14 3 20-7M34 34c10-2 20 2 18 10-3 9-14 3-20-7" />
      <path className="brand-body" d="M32 17v35M28 21h8M28 31h8M29 41h6" />
      <circle className="brand-body" cx="32" cy="13" r="3" />
    </svg>
  );
}

export function Brand() {
  const { config } = useBranding();
  return (
    <a className="brand" href="/" aria-label={`${config.siteName} Community Calendar home`}>
      <DragonflyMark />
      <span>
        <b>{config.siteName}</b>
        <small>Community calendar</small>
      </span>
    </a>
  );
}
